import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  initializeMultipageForm,
  clearMultipageForm,
} from 'Store/forms/actions';
import { getActiveUser } from 'Store/reducers';

import { getSessionStorage, deleteSessionStorage } from '../../utilities';
import { getPaidLicenseByType } from '../../settings/pricing-options';

class LoggedOutPayment extends React.PureComponent {
  componentDidMount() {
    const { location } = this.props;
    const stateValues =
      location.state && location.state.licenseType
        ? {
            licenseType: getPaidLicenseByType[location.state.licenseType],
          }
        : null;
    const sessionValues = getSessionStorage('loggedOutPayment');

    let initialValues;
    if (sessionValues) initialValues = sessionValues;
    if (stateValues)
      initialValues = {
        ...sessionValues,
        ...stateValues,
      };
    this.props.initializeMultipageForm('loggedOutPayment', initialValues);
  }

  componentDidUpdate() {
    if (this.props.activeUser) {
      deleteSessionStorage('loggedOutPayment');
    }
  }

  componentWillUnmount() {
    this.props.clearMultipageForm('loggedOutPayment');
  }

  render() {
    return this.props.children;
  }
}

LoggedOutPayment.propTypes = {
  children: PropTypes.node,
  initializeMultipageForm: PropTypes.func.isRequired,
  clearMultipageForm: PropTypes.func.isRequired,
  activeUser: PropTypes.object,
  location: PropTypes.shape({
    state: PropTypes.shape({
      licenseType: PropTypes.string,
    }),
  }),
};

const mapStateToProps = state => {
  return {
    activeUser: getActiveUser(state),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    initializeMultipageForm,
    clearMultipageForm,
  })(LoggedOutPayment)
);
